import { useTokenBalance } from "@src/hooks";
import { TokenWithChain } from "@src/models";
import { Skeleton } from "../Skeleton";
interface Props {
  token?: TokenWithChain;
  onMaxClick: (balance: string) => void;
  isFetchingBalances: boolean;
  smartWalletAddress?: string;
}

export const MaxBalance = ({
  token,
  onMaxClick,
  isFetchingBalances,
  smartWalletAddress,
}: Props) => {
  const tokenBalances = useTokenBalance({ token });

  return (
    <div className="flex gap-1 items-center">
      <div className="flex gap-[2px] text-xs leading-2 text-text_primary items-center">
        <span>Balance:</span>
        {isFetchingBalances ? (
          <Skeleton className="w-6 h-3" />
        ) : (
          <span>{smartWalletAddress ? tokenBalances.abbreviated : "-"}</span>
        )}
      </div>
      <button
        type="button"
        onClick={(e) => {
          if (!isFetchingBalances) {
            onMaxClick(tokenBalances.humanReadable);
          }
          e.stopPropagation();
        }}
        aria-label="Max"
        className="text-xs font-bold text-theme_color"
      >
        Max
      </button>
    </div>
  );
};
